import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "bg"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  id: "bdmap",
  class: "bdmap",
  ref: "bdmap"
};
const _hoisted_7 = {
  key: 0,
  class: "routeDialog"
};
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
  key: 2,
  class: "suggest",
  target: "_blank",
  href: "https://office.chaoxing.com/apps/forms/web/apply.html?id=1707447&formAppId=&enc=67a5179209298ff2d6ea26625ea13978&fidEnc=6f11b96ac0e97d33&uid=63888549&mappId=18111425&formid=1707447&roleid=217&rolename=%E8%B6%85%E7%BA%A7%E7%AE%A1%E7%90%86%E5%91%98&topMenu=&mappIdEnc=21195c47de3cb9a6dedcd3df402bb1f6&permissionGroupId=&appId=fb9fc363694441499aeca3e9835103f8&appKey=8V05Gg3RhQ3r3hTn&code=yf1EbxgP&state=166970&defaultUid=173679788&uuid=a4b0a6b8f9ed4c1888a1929a3fe78e6f&checkCode=20170cfa814944f9af58f7e27c9724a2#/"
};
const _hoisted_10 = {
  key: 3,
  class: "suggest",
  href: "https://cv.chaoxing.com/wechatAuth/appDetail?appid=364bc08d1f3b6f29&fid=6215e2acd865ee98"
};
const _hoisted_11 = {
  key: 4,
  class: "views"
};
const _hoisted_12 = {
  key: 5,
  href: "https://47q9j5qb.mh.chaoxing.com/",
  target: "_blank",
  class: "geyou"
};
const _hoisted_13 = {
  src: "https://p.ananas.chaoxing.com/star3/origin/9dc0299be9cc0f86474ab0cc9178d9ef.png",
  alt: ""
};
const _hoisted_14 = {
  src: "https://p.ananas.chaoxing.com/star3/origin/28940f60b136e3daa8a325fd3b753c0f.png",
  alt: ""
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  key: 7,
  class: "share_box"
};
const _hoisted_17 = {
  class: "share_head"
};
const _hoisted_18 = {
  class: "share_content"
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  key: 1
};
const _hoisted_21 = {
  class: "ds-bottom-menu"
};
const _hoisted_22 = ["href"];
const _hoisted_23 = {
  key: 8,
  class: "share_box wenlv_box"
};
const _hoisted_24 = {
  class: "share_head"
};
const _hoisted_25 = {
  class: "share_content"
};
const _hoisted_26 = {
  class: "wenlv_qrcode",
  ref: "wenlvQrcode"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mapv2assembly = _resolveComponent("mapv2assembly");
  const _component_typev2 = _resolveComponent("typev2");
  const _component_mappopupv2 = _resolveComponent("mappopupv2");
  const _component_pointlistv2 = _resolveComponent("pointlistv2");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_routelist = _resolveComponent("routelist");
  const _component_CloseBold = _resolveComponent("CloseBold");
  const _component_el_icon = _resolveComponent("el-icon");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mapContainer", {
      'isMobile': $props.isMobile
    }]),
    style: _normalizeStyle($data.mainStyle)
  }, [_createElementVNode("div", {
    class: _normalizeClass([`formUserId${$data.formUserId}`]),
    style: {
      "width": "100%",
      "height": "100%",
      "position": "relative"
    }
  }, [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: $data.mapelem.bg
  }, null, 8, _hoisted_2)], 512), [[_vShow, $data.mapelem.bg !== '']]), _withDirectives(_createElementVNode("div", {
    class: "logo",
    style: _normalizeStyle($data.modulestyle.logo)
  }, [_createElementVNode("img", {
    src: $data.mapelem.logo
  }, null, 8, _hoisted_3)], 4), [[_vShow, $data.mapelem.logo !== '']]), _withDirectives(_createElementVNode("div", {
    class: "pickey",
    style: _normalizeStyle($data.modulestyle.pickey)
  }, [_createElementVNode("img", {
    src: $data.mapelem.pickey
  }, null, 8, _hoisted_4)], 4), [[_vShow, $data.mapelem.pickey !== '']]), $data.loadingmap ? (_openBlock(), _createBlock(_component_mapv2assembly, {
    key: 0,
    ref: "mapv2assembly",
    id: $props.id,
    showgdtilelayer: $data.mapLayers.tiles,
    showgeojsonlayer: $data.mapLayers.json,
    showstaticlayer: $data.mapLayers.static,
    showroutelayer: $data.mapLayers.route,
    staticimage: $data.mapLayers.staticimage,
    drawelement: $data.mapLayers.drawelement,
    geojson: $data.mapLayers.geojson,
    mapstyle: $data.mapstyle,
    adcode: $data.mapview.adcode,
    zoom: $data.mapview.zoom,
    minZoom: $data.mapview.minZoom,
    maxZoom: $data.mapview.maxZoom,
    extent: $data.mapview.extent,
    center: $data.mapview.center,
    scale: $data.mapview.scale,
    rotate: $data.mapview.rotate,
    translate: $data.mapview.translate,
    rotation: $data.mapview.rotation,
    streetcode: $data.mapstreetcode,
    pointlist: $data.pointList,
    culturallist: $data.mapculturalList,
    isMobile: $data.isMobileflag,
    location: $data.bdmaploaction,
    routepoint: $data.routePoint,
    onSingleclick: $options.singleclick,
    onMarkerclick: $options.markerclick,
    onMarkermoveend: $options.markermoveend
  }, null, 8, ["id", "showgdtilelayer", "showgeojsonlayer", "showstaticlayer", "showroutelayer", "staticimage", "drawelement", "geojson", "mapstyle", "adcode", "zoom", "minZoom", "maxZoom", "extent", "center", "scale", "rotate", "translate", "rotation", "streetcode", "pointlist", "culturallist", "isMobile", "location", "routepoint", "onSingleclick", "onMarkerclick", "onMarkermoveend"])) : _createCommentVNode("", true), _createVNode(_component_typev2, {
    ref: "typev2",
    modeltype: $data.modeltype,
    typeshowflag: $data.form.showtype,
    typelist: $data.typeList,
    typebtnstyle: $data.typebtn,
    posstyle: $data.modulestyle.type,
    showtypeall: $data.mapstyle.typeall,
    typeallname: $data.mapstyle.typeallname,
    onTypeselect: $options.typeselect
  }, null, 8, ["modeltype", "typeshowflag", "typelist", "typebtnstyle", "posstyle", "showtypeall", "typeallname", "onTypeselect"]), _createVNode(_component_mappopupv2, {
    ref: "pointpop",
    detail: $data.pointdetail,
    popshowflag: $data.popshowflag,
    modeltype: $data.popmodeltype,
    isMobile: $data.isMobileflag,
    id: $props.id,
    onCloseHandle: $options.closeHandle
  }, null, 8, ["detail", "popshowflag", "modeltype", "isMobile", "id", "onCloseHandle"]), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["golist", `fid${$data.query.fid}`]),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.golist && $options.golist(...args))
  }, [_createElementVNode("img", {
    src: $data.mapelem.golist,
    alt: ""
  }, null, 8, _hoisted_5)], 2), [[_vShow, $data.showgolist]]), $data.cTemplateScore === 1 ? (_openBlock(), _createBlock(_component_pointlistv2, {
    key: 1,
    ref: "pointlist",
    listshowflag: $data.form.showlist,
    formoption: $data.cformoption,
    datalist: $data.mapculturalList,
    modeltype: $props.style.listStyleIndex,
    style: _normalizeStyle($data.modulestyle.list),
    isMobile: $data.isMobileflag,
    onListclick: $options.pointlistClick,
    onListup: $options.listUp
  }, null, 8, ["listshowflag", "formoption", "datalist", "modeltype", "style", "isMobile", "onListclick", "onListup"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, null, 512), _createVNode(_component_el_dialog, {
    modelValue: $data.routePop,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.routePop = $event),
    title: "路线详情",
    width: $data.isMobileflag ? '80%' : '40%'
  }, {
    default: _withCtx(() => [_ctx.routeDetail ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("h3", null, _toDisplayString(_ctx.routeDetail.itemformdata.title), 1), _createElementVNode("div", {
      class: "introduce",
      innerHTML: $options.formatIntroduce(_ctx.routeDetail.itemformdata.introduce)
    }, null, 8, _hoisted_8)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue", "width"]), _createVNode(_component_routelist, {
    ref: "routelist",
    typelist: $data.rtypeList,
    routelist: $data.maprouteList,
    pointlist: $data.pointList,
    style: _normalizeStyle($options.routeListStyle),
    isMobile: $data.isMobileflag,
    id: $props.id,
    onRoute: $options.routeChange
  }, null, 8, ["typelist", "routelist", "pointlist", "style", "isMobile", "id", "onRoute"]), _withDirectives(_createElementVNode("div", {
    class: "switchScreen",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.switchScreen && $options.switchScreen(...args))
  }, [...(_cache[10] || (_cache[10] = [_createElementVNode("img", {
    src: "https://p.ananas.chaoxing.com/star3/origin/20dce7a4bfee136fb7897495ed6d27b6.png",
    alt: ""
  }, null, -1)]))], 512), [[_vShow, $data.isMobileflag && $data.query.fid === '166970']]), false ? (_openBlock(), _createElementBlock("a", _hoisted_9, [...(_cache[11] || (_cache[11] = [_createElementVNode("img", {
    src: "https://p.ananas.chaoxing.com/star3/origin/14c36d63c08416e0ec07cf70c280eca7.png",
    alt: ""
  }, null, -1)]))])) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("a", _hoisted_10, [...(_cache[12] || (_cache[12] = [_createElementVNode("img", {
    src: "https://p.ananas.chaoxing.com/star3/origin/14c36d63c08416e0ec07cf70c280eca7.png",
    alt: ""
  }, null, -1)]))])) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_cache[13] || (_cache[13] = _createElementVNode("i", {
    class: "icon-view2"
  }, null, -1)), _createElementVNode("span", null, _toDisplayString($data.views), 1)])) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("a", _hoisted_12, [...(_cache[14] || (_cache[14] = [_createElementVNode("img", {
    src: "https://p.ananas.chaoxing.com/star3/origin/5e6bcac12db582c8a2e2c9614929bbf7.png",
    alt: ""
  }, null, -1)]))])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "audioBg",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.audiobgHandle && $options.audiobgHandle(...args))
  }, [_withDirectives(_createElementVNode("img", _hoisted_13, null, 512), [[_vShow, $data.playflag]]), _withDirectives(_createElementVNode("img", _hoisted_14, null, 512), [[_vShow, !$data.playflag]])]), _createElementVNode("audio", {
    ref: "bgaudio",
    id: "bgaudio",
    controls: "",
    autoplay: "",
    loop: "loop",
    src: $data.bgaudio,
    style: {
      "width": "0",
      "height": "0"
    }
  }, null, 8, _hoisted_15), false ? (_openBlock(), _createElementBlock("a", {
    key: 6,
    href: "javascript:void(0);",
    class: "share",
    onClick: _cache[4] || (_cache[4] = $event => $data.shareflag = true)
  }, [...(_cache[15] || (_cache[15] = [_createElementVNode("img", {
    src: "https://p.cldisk.com/star3/origin/6d09532a34a9b31f55fcb6f8642744ac.png",
    alt: ""
  }, null, -1)]))])) : _createCommentVNode("", true), $data.shareflag ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_cache[16] || (_cache[16] = _createElementVNode("h2", null, "二维码", -1)), _createVNode(_component_el_icon, {
    onClick: _cache[5] || (_cache[5] = $event => $data.shareflag = false)
  }, {
    default: _withCtx(() => [_createVNode(_component_CloseBold)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_18, [_cache[17] || (_cache[17] = _createElementVNode("img", {
    src: "https://p.cldisk.com/star3/origin/8aeef6a9607d2bcae1a558ea764532af.jpg?rw=100&rh=100&_fileSize=352755&_orientation=1",
    alt: ""
  }, null, -1)), !$data.isMobileflag ? (_openBlock(), _createElementBlock("p", _hoisted_19, "请打开手机相机或微信「扫一扫」，对准二维码即可查看")) : _createCommentVNode("", true), $data.isMobileflag ? (_openBlock(), _createElementBlock("p", _hoisted_20, "长按保存二维码或点击微信右上角“···”进行分享")) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", {
    class: _normalizeClass(["ds-bottom-menu__items", {
      open: $data.menuOpen
    }])
  }, [_createElementVNode("a", {
    href: "javascript:void(0);",
    class: "ds-bottom-menu__btn",
    onClick: _cache[6] || (_cache[6] = (...args) => $options.openWenlv && $options.openWenlv(...args))
  }, [...(_cache[18] || (_cache[18] = [_createElementVNode("img", {
    src: "https://p.cldisk.com/star4/265da314a2523af0d6ef4183771b1cb3/origin.png",
    alt: "东胜文旅"
  }, null, -1)]))]), _createElementVNode("a", {
    href: "javascript:void(0);",
    class: "ds-bottom-menu__btn",
    onClick: _cache[7] || (_cache[7] = (...args) => $options.openRouteFromMenu && $options.openRouteFromMenu(...args))
  }, [...(_cache[19] || (_cache[19] = [_createElementVNode("img", {
    src: "https://p.cldisk.com/star4/41d8f48cccf7b59d050cb468e707a45c/origin.png",
    alt: "线路推荐"
  }, null, -1)]))]), _cache[21] || (_cache[21] = _createElementVNode("a", {
    href: "https://47q9j5qb.mh.chaoxing.com/",
    target: "_blank",
    class: "ds-bottom-menu__btn"
  }, [_createElementVNode("img", {
    src: "https://p.cldisk.com/star4/5c55af4091fa56805782e5f7e1ba7ec1/origin.png",
    alt: "歌游内蒙古"
  })], -1)), _createElementVNode("a", {
    class: "ds-bottom-menu__btn",
    target: "_blank",
    href: $options.contactUsHref
  }, [...(_cache[20] || (_cache[20] = [_createElementVNode("img", {
    src: "https://p.cldisk.com/star4/eccb24d5fc7d0a00532ac6237498e07d/origin.png",
    alt: "联系我们"
  }, null, -1)]))], 8, _hoisted_22)], 2), _createElementVNode("a", {
    href: "javascript:void(0);",
    class: "ds-bottom-menu__trigger",
    onClick: _cache[8] || (_cache[8] = (...args) => $options.toggleMenu && $options.toggleMenu(...args))
  }, [...(_cache[22] || (_cache[22] = [_createElementVNode("img", {
    src: "https://p.cldisk.com/star4/2fee72d7c7359c6b6573bc987a6f92f1/origin.png",
    alt: "菜单"
  }, null, -1)]))])]), $data.wenlvflag ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_cache[23] || (_cache[23] = _createElementVNode("h2", null, "东胜文旅", -1)), _createVNode(_component_el_icon, {
    onClick: _cache[9] || (_cache[9] = $event => $data.wenlvflag = false)
  }, {
    default: _withCtx(() => [_createVNode(_component_CloseBold)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, null, 512), _cache[24] || (_cache[24] = _createElementVNode("p", null, "请使用微信「扫一扫」关注东胜文旅公众号", -1))])])) : _createCommentVNode("", true)], 2)], 6);
}